<script setup>
import { storeToRefs } from 'pinia'
import { ref, computed, onMounted, watch, inject } from 'vue'
import dayjs from 'dayjs'
import { useRouter } from 'vue-router'
import learningApiUser from '@src/services/api/learning/user'

const router = useRouter()
const rootAppProvide = inject('rootAppProvide')

const props = defineProps({
  courseId: {
    type: String,
    required: true
  }
})
const detail = ref(null)
const gmopay = ref(null)

const paymentInfo = computed(() => {
  console.log('paymentInfo', router.currentRoute.value.query.konbiniCode)
  let name = ''
  let type = ''
  let konbiniCode = ''
  if (router.currentRoute.value.query.payment_by === 'GMOPay/KONBINI') {
    type = 'KONBINI'
    konbiniCode = router.currentRoute.value.query.konbiniCode
    if (konbiniCode === 'SEVEN_ELEVEN') {
      name = '（コンビニ払い/セブンイレブン）'
    } else if (konbiniCode === 'LAWSON') {
      name = '（コンビニ払い/ローソン）'
    } else if (konbiniCode === 'FAMILYMART') {
      name = '（コンビニ払い/ファミリーマート）'
    } else if (konbiniCode === 'MINISTOP') {
      name = '（コンビニ払い/ミニストップ）'
    } else if (konbiniCode === 'SEICOMART') {
      name = '（コンビニ払い/セイコーマート）'
    }
  } else if (router.currentRoute.value.query.payment_by === 'GMOPay/BANK_TRANSFER_GMO_AOZORA') {
    type = 'BANK_TRANSFER_GMO_AOZORA'
    name = '（銀行振込）'
  } else if (router.currentRoute.value.query.payment_by === 'GMOPay/PAYEASY') {
    type = 'PAYEASY'
    name = '（ペイジー払い）'
  }
  return {
    title: name,
    type: type,
    konbiniCode: konbiniCode
  }
})

// 申込講座詳細取得
const getDetail = () => {
  rootAppProvide.value.openContentsLoading()
  console.log('props.courseId', props.courseId)
  learningApiUser.getTraineeDetail({
    params: {
      with: 'course.location'
    },
    custom: {
      params: { traineeId: props.courseId }
    }
  }).then((res) => {
    console.log('res', res.data)
    detail.value = res.data

    // 支払い状況を取得
    learningApiUser.getTraineeDetail({
      params: {
        with: 'payments_en'
      },
      custom: {
        params: { traineeId: props.courseId }
      }
    }).then((res) => {
      console.log('getTraineeDetail支払い状況取得 res', res.data)
      detail.value.payments_en = res.data.payments_en
      console.log('detail.value.payments_en.lenght', detail.value.payments_en[0])
      if (detail.value.payments_en[0] === undefined) {
        return false
      }
      gmopay.value = res.data.payments_en[0].gmopay
    }).catch((err) => {
      console.error('getTraineeDetail err', err)
    })
  }).catch((err) => {
    console.error('getDetail err', err)
  }).finally(() => {
    rootAppProvide.value.closeContentsLoading()
  })
}

onMounted(async () => {
  getDetail()
})
</script>

<template>
  <div class="container">
    <h2>お支払い方法について{{ paymentInfo.title }}</h2>

    <!-- セブンイレブン -->
    <div
      v-if="gmopay && paymentInfo.type === 'KONBINI' && paymentInfo.konbiniCode === 'SEVEN_ELEVEN'"
      class="detail"
    >
      <pre>
        □払込票でのお支払い
        <a :href="gmopay.voucherUrl" target="_blank">{{ gmopay.voucherUrl }}</a>（外部サイトが開きます）
        ※メールで通知される払込票URLをクリックしても払込票が表示されます。

        <b>■振込金額：<span style="text-decoration: underline">合計金額 ：{{ detail.payments_en[0].amount.toLocaleString() }}円（税込）</span></b>
        <b>　　　　　　 受講料 ：{{ (detail.payments_en[0].amount - detail.payments_en[0].commission.amount).toLocaleString() }}円（税込）</b>
        <b>　　　　　　 事務手数料 ：310円（税込）</b>

        －お支払いの前にお読みください－
        ・セブン-イレブン全店でお支払いいただけます。
        ・メールで通知される払込票URLを表示して、そのページをプリントアウトしてください。
        ・支払期限日の23時59分00秒までに、レジにてお支払いください。
        ・直接、レジにプリントアウトした払込票をご提示ください。
        ※お支払いにはクレジットカード・プリペイドカードはご利用いただけません。現金でお支払いください。

        --お支払い方法--
        1.メールで通知される払込票URLを表示して、そのページをプリントアウトしてください。
        2.直接、レジにプリントアウトした払込票をご提示ください。
        3.現金で商品代金をお支払いください。
        4.インターネットショッピング払込受領証が発行されますので、必ずお受け取りください。

        □レジでのお支払い
        <b>■払込票番号：{{ gmopay.receiptNumber }}</b>

        －お支払いの前にお読みください－
        ・セブン-イレブン全店でお支払いいただけます。
        ・お支払いの際、払込票番号が必要です。
        　メモを取るか、このページを印刷して、コンビニまでお持ちください。
        ※お支払いにはクレジットカード・プリペイドカードはご利用いただけません。現金でお支払いください。

        --お支払い方法--
        1.コンビニのレジスタッフに、上記払込票番号をご提示して頂き、「インターネット支払い」希望とお伝えください。
        2.現金で商品代金をお支払いください。
        3.インターネットショッピング払込受領証が発行されますので、必ずお受け取りください。
      </pre>
    </div>

    <!-- ローソン -->
    <div
      v-if="gmopay && paymentInfo.type === 'KONBINI' && paymentInfo.konbiniCode === 'LAWSON'"
      class="detail"
    >
      <pre>
        <b>■お客様番号：{{ gmopay.receiptNumber }}</b>
        <b>■確認番号：{{ gmopay.confirmationNumber }}</b>
        <b>■振込金額：<span style="text-decoration: underline">合計金額 ：{{ detail.payments_en[0].amount.toLocaleString() }}円（税込）</span></b>
        <b>　　　　　　 受講料 ：{{ (detail.payments_en[0].amount - detail.payments_en[0].commission.amount).toLocaleString() }}円（税込）</b>
        <b>　　　　　　 事務手数料 ：310円（税込）</b>

        －お支払いの前にお読みください－
        ・Loppiのあるローソン／ミニストップでお支払いいただけます。
        　申込券を発行してから30分以内にレジでお支払いください。
        ・お支払いの際、お客様番号と確認番号が必要です。
        　メモを取るか、このページを印刷して、コンビニまでお持ちください。
        ・申込券でのお支払いの場合、支払期限日の23時59分00秒までに、レジにてお支払いください。上記までに発券していれば、支払期限日を過ぎてもお支払いが可能です。
        　ただし、申込券発券後の有効期限は30分間です。
        ・お支払い店頭で領収証は発行されません。
        ・領収証はホームページよりダウンロードしてください。
        ※お支払いは現金のみとなります。

        －お支払い手順－
        1.トップページより「各種番号をお持ちの方」を選択してください。
        2.お客様番号 を入力し「次へ」を選択してください。
        3.確認番号 を入力し、「次へ」を選択してください。
        4.表示される内容を確認のうえ、「はい」を選択してください。
        5.印刷された申込券をレジに渡し、30分以内に現金でお支払いください。
        6.お支払い後、「払込受領証」を必ずお受け取りください。
      </pre>
    </div>

    <!-- ファミリーマート -->
    <div
      v-if="gmopay && paymentInfo.type === 'KONBINI' && paymentInfo.konbiniCode === 'FAMILYMART'"
      class="detail"
    >
      <pre>
        <b>■第１番号：{{ gmopay.confirmationNumber }} (5桁)</b>
        <b>■第２番号：{{ gmopay.receiptNumber }} (12桁)</b>
        <b>■振込金額：<span style="text-decoration: underline">合計金額 ：{{ detail.payments_en[0].amount.toLocaleString() }}円（税込）</span></b>
        <b>　　　　　　 受講料 ：{{ (detail.payments_en[0].amount - detail.payments_en[0].commission.amount).toLocaleString() }}円（税込）</b>
        <b>　　　　　　 事務手数料 ：310円（税込）</b>

        －お支払いの前にお読みください－
        ・マルチコピー機のあるファミリーマートでお支払いいただけます。
        　申込券を発行してから30分以内にレジでお支払いください。
        ・申込券でのお支払いの場合、支払期限日の23時59分00秒までに、レジにてお支払いください。上記までに発券していれば、支払期限日を過ぎてもお支払いが可能です。
        ただし、申込券発券後の有効期限は30分間です。
        ・お支払い店頭で領収証は発行されません。
        ・領収証はホームページよりダウンロードしてください。
        ・マルチコピー機でお支払いの場合
        　お支払いの際、企業コードと注文番号が必要です。
        　メモを取るか、このページを印刷して、コンビニまでお持ちください。
        ・バーコードでのお支払いの場合
        　お支払い方法に記載のURLからバーコードを取得後、コンビニのレジにご提示ください。
        　スマートフォンのみご利用いただけます。
        ※店頭でのお支払いには楽天Edyはご利用いただけません。現金でお支払いください。

        --お支払い方法--
        【マルチコピー機でのお支払いの場合】
        1.トップページより「代金支払い／チャージ（コンビニでお支払い Payment／Charge）」を選択してください。
        2.受領書に関する注意事項を確認し、｢次へ｣を選択してください。
        3.｢番号入力｣を選択してください。
        3.第１番号 (5桁) を入力し、「OK」を選択してください。
        4.第２番号 (12桁) を入力し、「OK」を選択してください。
        5.注意事項を確認のうえ、「同意して進む」を選択してください。
        6.お支払内容確認画面を確認のうえ、「確認」を選択してください。
        7.印刷された申込券をレジに渡し、30分以内にお支払いください。
        8.お支払い後、「レシート（受領書）」を必ずお受け取りください。

        【バーコードでのお支払いの場合】
        1.バーコード取得用URLをご参照ください。お支払い用バーコードが表示されます。
        2.バーコードをコンビニのレジにて提示し、お支払いください。
        3.お支払い後、「レシート（受領書）」を必ずお受け取りください。
        (バーコード取り扱い不可の場合はマルチコピー機でお支払いいただきます。)
        [バーコード取得用URL]
        <a :href="'https://ncpfa.famima.com/prd/ebcweb?firstKey=' + gmopay.confirmationNumber + '&secondKey=' + gmopay.receiptNumber + '&cpNo=001&gyNo=00'" target="_blank">https://ncpfa.famima.com/prd/ebcweb?firstKey={{ gmopay.confirmationNumber }}&secondKey={{ gmopay.receiptNumber }}&cpNo=001&gyNo=00'</a>（外部サイトが開きます）
      </pre>
    </div>

    <!-- ミニストップ -->
    <div
      v-if="gmopay && paymentInfo.type === 'KONBINI' && paymentInfo.konbiniCode === 'MINISTOP'"
      class="detail"
    >
      <pre>
        <b>■お客様番号：{{ gmopay.confirmationNumber }}</b>
        <b>■確認番号：{{ gmopay.receiptNumber }}</b>
        <b>■振込金額：<span style="text-decoration: underline">合計金額 ：{{ detail.payments_en[0].amount.toLocaleString() }}円（税込）</span></b>
        <b>　　　　　　 受講料 ：{{ (detail.payments_en[0].amount - detail.payments_en[0].commission.amount).toLocaleString() }}円（税込）</b>
        <b>　　　　　　 事務手数料 ：310円（税込）</b>

        －お支払いの前にお読みください－
        ・Loppiのあるローソン／ミニストップでお支払いいただけます。
        　申込券を発行してから30分以内にレジでお支払いください。
        ・お支払いの際、お客様番号と確認番号が必要です。
        　メモを取るか、このページを印刷して、コンビニまでお持ちください。
        ・申込券でのお支払いの場合、支払期限日の23時59分00秒までに、レジにてお支払いください。上記までに発券していれば、支払期限日を過ぎてもお支払いが可能です。
        　ただし、申込券発券後の有効期限は30分間です。
        ・お支払い店頭で領収証は発行されません。
        ・領収証はホームページよりダウンロードしてください。
        ※お支払いは現金のみとなります。

        －お支払い手順－
        1.トップページより「各種番号をお持ちの方」を選択してください。
        2.お客様番号 を入力し「次へ」を選択してください。
        3.確認番号 を入力し、「次へ」を選択してください。
        4.表示される内容を確認のうえ、「はい」を選択してください。
        5.印刷された申込券をレジに渡し、30分以内に現金でお支払いください。
        6.お支払い後、「払込受領証」を必ずお受け取りください。

      </pre>
    </div>

    <!-- セイコーマート -->
    <div
      v-if="detail && gmopay && paymentInfo.type === 'KONBINI' && paymentInfo.konbiniCode === 'SEICOMART'"
      class="detail"
    >
      <pre>
        <b>■受付番号：{{ gmopay.receiptNumber }}</b>
        <b>■確認番号：{{ gmopay.confirmationNumber }}</b>
        <b>■振込金額：<span style="text-decoration: underline">合計金額 ：{{ detail.payments_en[0].amount.toLocaleString() }}円（税込）</span></b>
        <b>　　　　　　 受講料 ：{{ (detail.payments_en[0].amount - detail.payments_en[0].commission.amount).toLocaleString() }}円（税込）</b>
        <b>　　　　　　 事務手数料 ：310円（税込）</b>

        －お支払いの前にお読みください－
        ・セイコーマートでお支払いいただけます。
        ・お支払いの際、受付番号と確認番号が必要です。
        　メモを取るか、このページを印刷して、コンビニまでお持ちください。
        ・お支払い店頭で領収証は発行されません。
        ・領収証はホームページよりダウンロードしてください。
        ※店頭でのお支払いには楽天Edyはご利用いただけません。現金でお支払いください。

        --お支払い方法--
        1.コンビニエンスストアのレジスタッフに、「インターネット支払い」とお伝えください。
        2.スタッフがレジを操作後に、入力画面が表示されます。
        3.受付番号を入力し、「登録」を選択してください。
        4.確認番号を入力し、「登録」を選択してください。
        5.お支払い内容が表示されますので、内容が正しいことをご確認のうえ、「OK」を選択してください。
        6.現金で商品代金をお支払いください。
        7.受領証が発行されますので、必ずお受け取りください。

      </pre>
    </div>

    <!-- 銀行振込 -->
    <div
      v-if="gmopay && paymentInfo.type === 'BANK_TRANSFER_GMO_AOZORA'"
      class="detail"
    >
      <pre>
        下記の内容にて口座振込のお申し込みを受け付けましたのでご確認の上、
        お支払い手続きをお願い致します。
        ■お支払い内容
        ------------------------------------
        <b>銀行コード ：{{ gmopay.bankCode }}</b>
        <b>銀行名 ：{{ gmopay.bankName }}</b>
        <b>支店コード ：{{ gmopay.branchCode }}</b>
        <b>支店名 ：{{ gmopay.branchName }}</b>
        <b>科目名 ：{{ gmopay.accountType }}</b>
        <b>口座番号 ：{{ gmopay.accountNumber }}</b>
        <b>口座名義 ：{{ gmopay.accountHolderName }}</b>
        <b>振込金額：　<span style="text-decoration: underline">合計金額 ：{{ detail.payments_en[0].amount.toLocaleString() }}円（税込）</span></b>
        <b>　　　　　　受講料 ：{{ (detail.payments_en[0].amount - detail.payments_en[0].commission.amount).toLocaleString() }}円（税込）</b>
        <b>　　　　　　事務手数料 ：90円（税込）</b>
        <!--
        <b>振込金額 ：{{ (detail.course.price + detail.course.tax.amount).toLocaleString() }}円</b>
        -->
        <b>オーダーID ：{{ detail.payments_en[0].id }}</b>
        <b>お支払期限 ：{{ dayjs(detail.payments_en[0].payment_term).format('YYYY年MM月DD日(dd) HH:mm') }}</b> ※１
        ------------------------------------
        ※１ お支払期限までに、振込み手続きを行ってください。
      </pre>
    </div>

    <!-- ペイジー -->
    <div
      v-if="gmopay && paymentInfo.type === 'PAYEASY'"
      class="detail"
    >
      <pre>
        <b>■収納機関番号：{{ gmopay.institutionCode }}</b>
        <b>■お客様番号：{{ gmopay.customerNumber }}</b>
        <b>■確認番号：{{ gmopay.confirmationNumber}}</b>
        <b>■振込金額：<span style="text-decoration: underline">合計金額 ：{{ detail.payments_en[0].amount.toLocaleString() }}円（税込）</span></b>
        <b>　　　　　　受講料 ：{{ (detail.payments_en[0].amount - detail.payments_en[0].commission.amount).toLocaleString() }}円（税込）</b>
        <b>　　　　　　事務手数料 ：310円（税込）</b>

        －お支払いの前にお読みください－
        ・お支払い可能な金融機関は以下からご確認いただけます。
        https://www.econtext.jp/bank_list/list.html
        ※金融機関により手数料が発生する場合がございます。詳しくはお取引の金融機関にお問合せください。
        ※法令改正のため、2007年1月4日より、ATMから10万円を超える現金の振込はできなくなりました。

        ・お支払いの際、収納機関番号、お客様番号、確認番号が必要です。
        メモを取るか、このページを印刷してお持ちください。
        ・ご利用明細票が領収書となりますので、お支払い後必ずお受け取りください。

        －お支払い手順－
        1.上記の金融機関のATMで、「税金・料金払込み」を選択してください。
        2.収納機関番号 を入力し、「確認」を選択してください。
        3.お客様番号 を入力し、「確認」を選択してください。
        4.確認番号 を入力し、「確認」を選択してください。
        5.表示される内容を確認のうえ、「確認」を選択してください。
        6.「現金」または「キャッシュカード」を選択し、お支払いください。
        7.ご利用明細票を必ずお受け取りください。

        ネットバンキングでのお支払い
        －お支払いの前にお読みください－
        ・金融機関にあらかじめ口座をお持ちの場合のみご利用いただけます。

        －お支払い手順－
        1.ご利用の金融機関の案内に従って、ペイジーでのお支払いにお進みください。
        2.収納機関番号、お客様番号、確認番号を入力してください。
        3.お支払い内容を確認のうえ、料金をお支払いください。
      </pre>
    </div>

    <!-- フッター -->
    <div class="btnContainer">
      <button
        class="c-button c-button--medium c-button--border"
        @click="router.go(-1)"
      >
        トップページに戻る
      </button>
    </div>
  </div>
</template>

<style scoped lang="scss">
.container {
  h2 {
    padding: 30px 0 15px;
    font-size: 26px;
    text-align: left;
    font-weight: bold;
  }

  .detail {
    width: 100%;
    
    pre {
      white-space: -moz-pre-wrap;
      white-space: -pre-wrap;
      white-space: -o-pre-wrap;
      white-space: pre-wrap;
      word-wrap: break-word;

      p {
        font-weight: bold;
        font-size: 16px;
      }

      a {
        display: inline-block;
        color: rgba(0, 0, 238, 1);
        text-decoration: underline;
      }
    }
  }

  /* フッターボタン */
  .btnContainer {
    display: flex;
    width: auto;
    margin: 20px auto;
    justify-content: center;

    button {
      width: 200px;

      &:nth-child(2) {
        margin-left: 20px;
      }
    }
  }
}
</style>
